module.exports = __webpack_public_path__ + "media/images/ra-review-white-885ae53570f777eb3f3794b96110cf93.svg";